import { ORDER_STATUS_LABELS_RU } from '@crm/shared'
import type { OrderRow, OrderStatus as OrderStatusT } from '@crm/shared'
import { ORDER_STATUS_STYLE, formatMoney } from '../orderFormat'

// Порядок ступеней воронки продаж (без архива — он сквозной).
const FUNNEL_ORDER: OrderStatusT[] = [
  'NEW',
  'PENDING_ROP',
  'CONFIRMED',
  'AWAITING_PAYMENT',
  'PARTIALLY_PAID',
  'PAID',
  'CLOSED',
  'CANCELLED',
]

/**
 * Виджет «Воронка продаж» по заказам: количество и сумма по каждому статусу.
 * Считается по заказам, видимым в таблице: выборка списка (статус, поиск)
 * плюс фильтры колонок таблицы (`filtered`).
 */
export function OrderFunnel({
  orders,
  partial = false,
  filtered = false,
}: {
  orders: OrderRow[]
  partial?: boolean
  filtered?: boolean
}) {
  const byStatus = new Map<OrderStatusT, { count: number; sum: number }>()
  for (const o of orders) {
    const cur = byStatus.get(o.status) ?? { count: 0, sum: 0 }
    cur.count += 1
    cur.sum += o.totalSum
    byStatus.set(o.status, cur)
  }
  const steps = FUNNEL_ORDER.filter((s) => byStatus.has(s))
  if (steps.length === 0 && !filtered) return null

  return (
    <div className="rounded-xl border border-gray-200 bg-white p-3">
      <h2 className="mb-2 text-sm font-semibold text-gray-700">
        Воронка продаж
        {filtered && (
          <span className="ml-2 font-normal text-xs text-brand-600">
            по фильтру таблицы, заказов: {orders.length}
          </span>
        )}
        {partial && (
          <span className="ml-2 font-normal text-xs text-amber-600">
            по загруженным {orders.length} заказам — нажмите «Загрузить ещё» для полной картины
          </span>
        )}
      </h2>
      {steps.length === 0 && (
        <p className="text-sm text-gray-500">Под фильтр таблицы не попал ни один заказ.</p>
      )}
      <div className="flex flex-wrap gap-2">
        {steps.map((s) => {
          const d = byStatus.get(s)!
          return (
            <div
              key={s}
              className={`min-w-[120px] rounded px-3 py-2 ${ORDER_STATUS_STYLE[s]}`}
              title={ORDER_STATUS_LABELS_RU[s]}
            >
              <div className="text-xs font-medium">{ORDER_STATUS_LABELS_RU[s]}</div>
              <div className="text-lg font-semibold">{d.count}</div>
              <div className="text-xs opacity-80">{formatMoney(d.sum)}</div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
